import { render, staticRenderFns } from "./AskOfficeForNewAppointment.vue?vue&type=template&id=516195b4&"
import script from "./AskOfficeForNewAppointment.vue?vue&type=script&lang=js&"
export * from "./AskOfficeForNewAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports